import {type FC, useCallback} from 'react';

import type {SelectOption} from '../../../../uikit/Select/types';
import type {PayloadAction} from '../../../../utils/events';
import type {BookConferenceStore} from '../../BookConference.store';

import {Select} from '../../../../uikit/Select';
// TODO: Not touch
import {TestID} from '../../../../utils/test-utils/data-test-id';

export const CoachesSelect: FC<{
  store: BookConferenceStore['strategy']['coaches'];
}> = ({store}) => {
  const onSelect = useCallback(
    (action: PayloadAction<SelectOption>) => {
      if (action.payload) {
        store.onSelect(action.payload.value as string);
      }
    },
    [store],
  );

  return (
    <Select
      defaultValue={{
        label: store.selected[0]!.entity.name,
        value: store.selected[0]!.id,
      }}
      onChange={onSelect}
      options={store.all.entries.map(c => ({
        label: c.entity.name,
        value: c.id,
      }))}
      testID={TestID.bookConference.input.coachSelect}
    />
  );
};
